import React from 'react';

import PropTypes from 'prop-types';

import { Text, TextType } from 'ui-components/components/text';

import messages from './messages';
import LabelDetails from '../../../../rate-card/read-only/label-details/label-details';
import { OrderDetailsTabSection } from '../../../../tab-section/section';

import style from './return-voided-label-section.module.less';

const ReturnVoidedLabelSection = ({ labelProviderId, serviceName, trackingNumber, trackingUrl }) => {
  return (
    <OrderDetailsTabSection
      ariaLabelMessageDescriptor={messages.voidedReturnSectionAriaLabel}
      className={style['return-voided-label-section']}
    >
      <Text
        className={style['return-voided-label-section-title']}
        element='h2'
        textType={TextType.H4}
        value={messages.voidedReturnSectionTitle}
      />
      <LabelDetails
        isVoided
        labelProviderId={labelProviderId}
        serviceName={serviceName}
        trackingNumber={trackingNumber}
        trackingUrl={trackingUrl}
      />
    </OrderDetailsTabSection>
  );
};

export { ReturnVoidedLabelSection };

ReturnVoidedLabelSection.propTypes = {
  labelProviderId: PropTypes.string,
  serviceName: PropTypes.string,
  trackingUrl: PropTypes.string,
  trackingNumber: PropTypes.string,
};
